import { courseCategoryList } from "constants/courseCategory";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

//get course category listing
export const getCourseCategoryList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.course_category_list(pageNum, filters);
    dispatch({ type: courseCategoryList, payload: res.data });
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({
      type: courseCategoryList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};

//add course category
export const addCourseCategory = async (bodyData) => {
  try {
    const res = await api.add_course_category(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

//edit or update the course category
export const editCourseCategory = async (id, bodyData) => {
  try {
    const res = await api.edit_course_category(id, bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};

//get course category details by id
export const getCourseCategoryDetailByID = async (id) => {
  try {
    const res = await api.get_courseCategory_details_ID(id);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
};
